import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { VariantService } from 'src/app/angularJS/services/variant/variant.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

/**
 * A controller used to edit a variant on a product
 */
export class VariantEditController {
  public static $inject = [
    '$state',
    '$stateParams',
    '$rootScope',
    'UserMessages',
    'ACTToolbarService',
    'catalogueConstants',
    'variantService',
    'breadcrumbService'
  ];

  public required: InterACT.Interfaces.Catalogues.Variant;
  public currentSchemaId: string;
  public channelAvailableValues: Array<string>;
  private catalogue: InterACT.Interfaces.Catalogues.Catalogue;
  private product: InterACT.Interfaces.Catalogues.Product;

  constructor(
    private $state: ng.ui.IStateService,
    private $stateParams,
    private $rootScope,
    private UserMessages: UserMessagesService,
    private ActToolbarService: ACTToolbarService,
    private catalogueConstants: InterACT.Interfaces.ICatalogueConstants,
    private variantService: VariantService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.activate();
  }

  /**
   * Edits the variant by merging the data entered in the form with the required data
   * @param data the variant data entered in the form
   * @returns a promise from the variant service
   */
  public editVariant = (data: InterACT.Interfaces.Catalogues.Variant) => {
    _.merge(this.required, data);
    this.required.fields = this.getDifference(data.fields, this.product.fields);
    this.$rootScope.showSpinner = true;
    return this.variantService.update(this.catalogue.id, this.product.id, this.required.id, this.required).then(() => {
      this.$rootScope.showSpinner = false;
      this.UserMessages.showToast('TOAST_MESSAGE.VARIANT.EDITED');
      this.exitEditVariant();
    });
  }

  /**
   * Exits the edit variant view to the variants list view
   * @returns a promise from the state provider
   */
  public exitEditVariant = () => {
    this.$state.go('variants.list', {
      catalogueId: this.catalogue.id,
      catalogueVersion: this.catalogue.version,
      productId: this.product.id
    });
  }

  /**
   * Initialises the controller
   */
  private activate() {
    this.catalogue = this.$stateParams.catalogue;
    this.product = this.$stateParams.product;
    this.required = this.$stateParams.editableVariant;
    this.required.fields = _.merge({}, this.product.fields, this.required.fields);
    this.currentSchemaId = this.product.type;
    this.channelAvailableValues = this.catalogueConstants.CHANNELS;
    this.breadcrumbService.setBreadcrumbs([
      {
        name: 'CATALOGUES',
        sref: 'catalogues.list'
      }, {
        name: this.catalogue.scheme.abbreviation,
        sref: 'catalogue.product-list',
        params: {
          catalogueId: this.catalogue.id,
          catalogueVersion: this.catalogue.version
        }
      }, {
        name: this.product.name,
        sref: 'variants.list',
        params: {
          catalogueId: this.catalogue.id,
          catalogueVersion: this.catalogue.version,
          productId: this.product.id
        }
      }
    ]);

    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle('HEADING.EDIT_VARIANT');
    });

    this.$rootScope.showSpinner = true;
    this.variantService.getVariant(this.catalogue.id, this.product.id, this.required.id).then((response) => {
      this.$rootScope.showSpinner = false;
      angular.extend(this.required, response);
      this.required.fields = _.merge({}, this.product.fields, this.required.fields);
    });
  }

  /**
   * Retrieves any differing attributes between two objects
   * Found: https://gist.github.com/Yimiprod/7ee176597fef230d1451
   * Lack of support currently in lodash
   * @param updatedObject the object where the changes where enacted
   * @param originalObject the base object serving as the starting point
   * @returns an object containing only the altered fields
   */
  private getDifference(updatedObject, originalObject) {
    return _.transform(updatedObject, (result, value, key) => {
      if (!_.isEqual(value, originalObject[key])) {
        result[key] = (_.isObject(value) && _.isObject(originalObject[key]))
          ? this.getDifference(value, originalObject[key])
          : value;
      }
    });
  }
}